export const ApiRoutes = {
  EMAIL_VERIFICATION: '/api/v1/accounts/send-verification-email',
  JOIN: '/pro/api/v1/users/join',
  ME: '/pro/api/v1/users/me',

  THREADS: '/pro/api/v1/threads/',
  THREAD_DETAILS: (threadId: string) => `/pro/api/v1/threads/${threadId}`,

  THREAD_AGENT_RESPONSE_FEEDBACK: (threadId: string) => `/pro/api/v1/threads/${threadId}/feedbacks`,
  THREAD_METADATA: (threadId: string) => `/public/pro/api/v1/threads/${threadId}/metadata`,
  THREAD_METADATA_KEY: (threadId: string, metadataKey: string) =>
    `/public/pro/api/v1/threads/${threadId}/metadata/${metadataKey}`,
  THREAD_CANCEL: (threadId: string) => `/public/pro/api/v1/threads/${threadId}/cancel`,

  SPEECH_TO_TEXT: `api/v1/audio/stt`,
  TEXT_TO_SPEECH: `api/v1/audio/tts`,

  VERIFY: '/pro/api/v1/fineco/verify',
  LOGOUT: '/pro/api/v1/fineco/logout',
  TTL: '/pro/api/v1/fineco/ttl',

  FINECO_PORTFOLIO_REPORT_DATA: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/report/data`,
  FINECO_PORTFOLIO_REPORT_EXCEL: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/report/excel`,
  FINECO_PORTFOLIO_PTF: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/ptf`,
  FINECO_PORTFOLIO_REPORT_PARAMETERS: (portfolioId: string) =>
    `/pro/api/v2/fineco/portfolios/${portfolioId}/report/parameters`,
  FINECO_PORTFOLIO_STORY: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/story`,
  FINECO_PORTFOLIO_REPORT_PDF: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/report/pdf`,
  FINECO_PORTFOLIOS_COMPARE: `/pro/api/v2/fineco/portfolios/compare`,
  FINECO_PORTFOLIO_SAVE: (portfolioId: string) => `/pro/api/v2/fineco/portfolios/${portfolioId}/save`,

  CREATE_PRODUCT_CARD_PDF: (isin: string) => `/pro/api/v1/fineco/product-card/${isin}`,

  //** Constraints */
  SEARCH_MICROCATEGORIES: (microCategorySearchString: string) =>
    `pro/api/v1/fineco/microcategories/search?query=${microCategorySearchString}`,
  SEARCH_PRODUCTS: (productSearchString: string) => `pro/api/v1/fineco/products/search?query=${productSearchString}`,
  MICROCATEGORY_NAMES: 'pro/api/v1/fineco/microcategory-names',
  PRODUCT_NAMES: (isins: string[]) => `pro/api/v1/fineco/product-names?isins=${isins.join(',')}`,

  CONSTRAINTS_DEFAULT: '/pro/api/v1/fineco/constraints/defaults',

  PTF_THREAD: '/pro/api/v2/fineco/ptf',
};
